import moment from 'moment';
import type Moment from 'moment';
import 'moment-precise-range-plugin';

const pluralize = (amount, string) => {
  if (amount > 1) {
    return `${string}s`;
  }

  return string;
};

export const calculateDuration = (
  start: Moment,
  end: Moment,
  upgradedEndTime: boolean = false
): string => {
  if (moment.isMoment(start) && moment.isMoment(end)) {
    const diff = moment(end).preciseDiff(start, true);

    const { years, months, days, hours, minutes } = diff;

    const underHour = !years && !months && !days && !hours && minutes;
    const underDay = !years && !months && !days && hours;
    const underYear = !years && months;

    let mDisplay;
    let minutesDisplay;
    let hoursDisplay;
    let daysDisplay;
    let displayMonth;
    let displayYear;

    if (upgradedEndTime) {
      mDisplay = underDay ? pluralize(minutes, ' minute') : '';
      minutesDisplay = underHour ? pluralize(minutes, ' minute') : mDisplay;
      hoursDisplay = underYear || years ? '' : pluralize(hours, ' hour');
      daysDisplay = years ? '' : pluralize(days, ' day');
      displayMonth = pluralize(months, ' month');
      displayYear = pluralize(years, ' year');
    } else {
      mDisplay = underDay ? 'm' : '';
      minutesDisplay = underHour ? pluralize(minutes, ' min') : mDisplay;
      hoursDisplay = underYear || years ? '' : 'h';
      daysDisplay = years ? '' : 'd';
      displayYear = 'y';
      displayMonth = 'mo';
    }

    const dict = {
      years: displayYear,
      months: displayMonth,
      days: daysDisplay,
      hours: hoursDisplay,
      minutes: minutesDisplay
    };

    return Object.keys(diff)
      .filter(key => key !== 'firstDateWasLater' && diff[key])
      .map(key => {
        const val = diff[key];
        const label = dict[key];

        if (!label) return null;

        return `${val}${label}`;
      })
      .join(' ')
      .trim();
  }
  return '---';
};

export const todayTomorrowDateFormat = (
  date: Moment,
  year: boolean = false,
  hideTime: boolean = false
) => {
  if (!date) {
    return '';
  }
  if (date.isSame(moment(), 'day')) {
    return hideTime ? date.format(`[Today]`) : date.format(`[Today at] HH:mm`);
  }

  if (date.isSame(moment().add(1, 'days'), 'day')) {
    return hideTime
      ? date.format('[Tomorrow]')
      : date.format('[Tomorrow at] HH:mm');
  }

  if (hideTime) {
    return year ? date.format('D MMM YYYY') : date.format('Do MMM');
  }

  return year
    ? date.format('D MMM YYYY [at] HH:mm')
    : date.format('Do MMM [at] HH:mm');
};

export const formatDurationFromSeconds = seconds =>
  calculateDuration(moment(), moment().add(seconds, 'seconds'));

export const defaultSearchDates = (() => {
  const now = moment();

  return {
    arriving: now.add(59, 'minutes').startOf('hour'),
    leaving: now.clone().add(2, 'hours')
  };
})();

export default null;
